export default {
  name: 'pc-video',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '视频',
          icon: 'el-icon-video-camera-solid',
          content: {
            img: '',
            video: '',
            height: 120
          },
          config: [{
            label: '视频高度',
            name: 'height',
            type: 'number',
            value: ''
          }, {
            label: '视频封面',
            name: 'img',
            type: 'upload',
            value: '',
            attrs: {
              accept: 'image/*',
              limit: 1,
              serialize: true
            }
          }, {
            label: '视频',
            name: 'video',
            type: 'upload',
            value: '',
            attrs: {
              accept: 'video/*',
              limit: 1,
              serialize: true
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};